export const AuditColumns = Object.freeze({
  DateTime: "DateTime",
  User: "User",
  Category: "Category",
  Type: "Type",
  Audit: "Audit",
});
